import { Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'uui-radiobutton',
  styleUrl: 'uui-radiobutton.css',
  // So we want radio buttons to work as expected in forms, and to have
  // radio group exclusivity, so they are NOT added to the shadow DOM.
  shadow: false,
  // However, for their styles to be correctly scoped as if they were
  // in the shadow root, we set this flag (and add :host to the globals).
  scoped: true
})
export class UUIRadioButton {
  @Prop({ mutable: true, reflect: false }) checked: boolean = false;
  @Prop() disabled: boolean = false;
  @Prop({ mutable: true, reflect: true }) error: boolean = false;
  @Prop({ mutable: true, reflect: true }) value: any = null;
  @Prop() name: string = '';
  @Event({ bubbles: true }) toggle?: EventEmitter<any>;
  @Event({ bubbles: true }) toggleChange?: EventEmitter<any>;
  @Prop() inputProps: { [key: string]: string };
  @Element() el: HTMLElement;

  _inputId = `_rb_${_radioButtonId++}`;

  get input() {
    return this.el.querySelector('input');
  }

  connectedCallback() {
    if (this.input) {
      this.input.checked = this.checked;
    }
  }

  onRadioButtonToggle(e) {
    console.warn(
      'toggle will be deprecated in a future release. Please use toggleChange.'
    );
    if (this.disabled) {
      return;
    }

    this.checked = this.input?.checked;
    this.toggle.emit(e);
  }

  onRadioButtonToggleChange(e) {
    if (this.disabled) {
      return;
    }

    this.checked = this.input?.checked;
    this.toggleChange.emit(e);
  }

  render() {
    return (
      <Host>
        <input
          type="radio"
          id={this._inputId}
          checked={this.checked}
          name={this.name}
          disabled={this.disabled}
          value={this.value}
          onChange={e => {
            if (this.toggleChange) {
              return this.onRadioButtonToggleChange(e);
            }
            this.onRadioButtonToggle(e);
          }}
          {...this.inputProps}
        />
        <label htmlFor={this._inputId}>
          <slot />
        </label>
      </Host>
    );
  }
}
let _radioButtonId = 0;
